<template>
  <v-container>
    <v-row class="pb-2">
      <v-col cols="5">
        <v-text-field
            hide-details="auto"
            outlined
            dense
            clearable
            v-model="filter['plant_name']"
            label="発電所名"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <v-col cols="5">
        <v-text-field
            hide-details="auto"
            outlined
            dense
            clearable
            v-model="filter['plant_address']"
            label="住所"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="4">
        <v-checkbox
            v-model="filter['checkbox']"
            :label="'Pix4Dのデータがあるもののみ表示'"
            @change="valueChanged"
        ></v-checkbox>
      </v-col> -->
      <v-col cols="2">
        <v-btn color="primary" height="40" block @click="searchPlant">
          <v-icon left>mdi-magnify-plus</v-icon>
          検索
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
        dense
        hide-default-footer
        :headers="tableHeaders"
        :items="plants"
        :page.sync="filter.page"
        :items-per-page="filter.per_page"
        :server-items-length="totalPlants"
        :loading="loading"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
        class="elevation-1"
        @click:row="(plant) => {
          viewData(plant)
        }" 
        
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>発電所一覧</b>
            <span>（{{ totalPlants }} 件）</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn color="primary" text @click="viewData(item)">データ一覧</v-btn>
      </template>
      <template
      v-slot:item.status="{ item }">
        <v-chip
            v-if="item.status === 'NEW'"
            color="default"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_QUEUEING'"
            color="secondary"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_PROCESSING'"
            color="primary"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_COMPLETED'"
            color="success"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_SKIP'"
            color="orange"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_ERROR'"
            color="error"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
      </template>
    </v-data-table>
    <div class="text-right pt-2">
      <v-pagination
          v-if="totalPlants > 0"
          v-model="filter.page"
          :length="totalPlants == 0 ? 0 : Math.ceil(totalPlants/10)"
          total-visible="9"
          @input="changePage"
      ></v-pagination>
    </div>
  </v-container>
</template>
<script>
// import {store} from "@/store";
export default {
  name: "H2pMainPlant",

  data: () => ({
    filter: {
      'plant_name': null,
      'plant_address': null,
      // 'checkbox': true,
      page: 1,
      per_page: 10,
    },
    loading: true,
    tableHeaders: [
      {
        text: "経産省ID",
        sortable: false,
        value: "plant_id",
      },
      {
        text: "発電所名",
        sortable: false,
        value: "plant_name",
      },
      {
        text: "住所",
        sortable: false,
        value: "plant_address",
      },
      {
        text: "抽出状況",
        sortable: false,
        value: "status",
        align: 'center',
      },
      {
        text: "アクション",
        sortable: false,
        value: "actions",
        align: 'center',
      },
    ],
    totalPlants: 0,
    plants: [],
    selectedPlantId: null,
  }),

  methods: {
    resetData() {
      this.loading = true;
      this.totalPlants = 0;
      this.plants = [];
      // this.tableHeaders = [
      //   {
      //     text: "経産省ID",
      //     sortable: false,
      //     value: "plant_id",
      //   },
      //   {
      //     text: "発電所名",
      //     sortable: false,
      //     value: "plant_name",
      //   },
      //   {
      //     text: "住所",
      //     sortable: false,
      //     value: "plant_address",
      //   },
      //   {
      //     text: "抽出状況",
      //     sortable: false,
      //     value: "status",
      //     align: 'center',
      //   },
      //   {
      //     text: "アクション",
      //     sortable: false,
      //     value: "actions",
      //     align: 'center',
      //   },
      // ]
    },
    getMainPlants() {
      this.resetData();
      if (this.filter.plant_name){
        this.filter.plant_name = this.filter.plant_name.trim().replaceAll("\\p{Z}", "");
      }
      if (this.filter.plant_address){
        this.filter.plant_address = this.filter.plant_address.trim().replaceAll("\\p{Z}", "");
      }
      // if (this.filter.checkbox != true){
      //   this.tableHeaders.splice(3, 1)
      // }
      this.axios
          .post("/api/h2p/main-plants", this.filter)
          .then((response) => {
            this.loading = false;
            this.plants = response.data;
            this.totalPlants = parseInt(response.headers["x-total"]);
          });
    },
    changePage() {
      this.getMainPlants();
    },
    searchPlant() {
      this.filter.page = 1;
      this.getMainPlants();
    },
    viewData(plant) {
      this.$router.push('/h2p/' + plant.id + '/data');
    },
    getStatusText(type) {
      const statusTypes = [
        { text: "未抽出", value: "NEW" },
        { text: "抽出待ち", value: "ARRAY_QUEUEING"},
        { text: "抽出中", value: "ARRAY_PROCESSING" },
        { text: "抽出完了", value: "ARRAY_COMPLETED"},
        { text: "抽出スキップ", value: "ARRAY_SKIP"},
        { text: "エラー", value: "ARRAY_ERROR"},
      ];
      return statusTypes.find(x => x.value == type).text;
    },
    handle(){
      this.searchPlant();
    }

    // valueChanged(){
    //   this.getMainPlants();
    // }
  
  },

  created() {
    this.getMainPlants();
  },
}
</script>

<style scoped>
.elevation-1 >>> tbody tr :hover {
  cursor: pointer;
}
.v-input--selection-controls {
    margin-top: 0px;
}
</style>
